import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'open_with_faire-shopify_offer_benefits_upsells_toast_toggle-click';
/**
 * Fires when clicking the open&#x2F;close toggle of the faire shopify benefits toast
 */
export function trackOpenWithFaireShopifyOfferBenefitsUpsellsToastToggleClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
